import { IconProps } from "../../utils/global-types/global-types";

const LeadStageIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    className={className ? className : "w-3.5 h-3.5"}
    {...rest}
  >
    <g clipPath="url(#ls_clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6556 0.3501H5.00559C3.90377 0.3501 3.01059 1.2433 3.01059 2.3451V3.0101H2.34559C1.24377 3.0101 0.350586 3.9033 0.350586 5.0051V11.6551C0.350586 12.7569 1.24377 13.6501 2.34559 13.6501H8.99559C10.0974 13.6501 10.9906 12.7569 10.9906 11.6551V10.9901H11.6556C12.7574 10.9901 13.6506 10.0969 13.6506 8.9951V2.3451C13.6506 1.2433 12.7574 0.3501 11.6556 0.3501ZM8.53078 6.7341L5.53759 10.7241C5.41437 10.8893 5.22119 10.9873 5.0154 10.9901C4.81097 10.9929 4.61498 10.9005 4.48619 10.7409L3.15619 9.0777C2.92657 8.7907 2.97278 8.3721 3.25979 8.1439C3.5468 7.9143 3.9654 7.9605 4.19498 8.2475L4.98877 9.2387L7.46539 5.9361C7.68657 5.6421 8.10377 5.5833 8.39778 5.8031C8.69039 6.0229 8.75059 6.4401 8.53078 6.7341ZM12.3206 8.9951C12.3206 9.3619 12.0224 9.6601 11.6556 9.6601H10.9906V5.0051C10.9906 3.9033 10.0974 3.0101 8.99559 3.0101H4.34059V2.3451C4.34059 1.9783 4.63877 1.6801 5.00559 1.6801H11.6556C12.0224 1.6801 12.3206 1.9783 12.3206 2.3451V8.9951Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="ls_clip">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LeadStageIcon;
